var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.loading)?_c('div',[(_vm.form_name)?_c(_vm.currentFormComponent,{tag:"component",attrs:{"initialData":_vm.formInitialData}}):_vm._e()],1):_c('div',[_c('div',{staticClass:"dotted-loader"}),_c('div',{staticClass:"h-80"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }